module.exports = __webpack_public_path__ + "img/5.54837d32.png";